






































import CityAutocomplete from '@/components/CityAutocomplete.vue';
import Vue from 'vue';
import { getCurrentLocationMixin } from '@/mixins/getCurrentLocationMixin';
import { round } from '@/filters/round';
import { LocationInterface } from '@/utils/location';

export default Vue.extend({
    name: 'HomeHero',

    components: {
        CityAutocomplete,
    },

    mixins: [
        getCurrentLocationMixin,
    ],

    methods: {
        getLocation() {
            this.getCurrentLocation()
                .then((location: LocationInterface) => {
                    const lat = round(location.lat, 4);
                    const lon = round(location.lon, 4);
                    this.$router.push(`/near/${lat},${lon}`);
                });
        },

        /**
         * @param {LocationInterface} location
         */
        citySelected(location: LocationInterface) {
            if (location) {
                this.$router.push(`/near/${location.lat},${location.lon}`);
            }
        },
    },
});
